import { ITextModelService } from 'vscode/vscode/vs/editor/common/services/resolverService';
import { TextModelResolverService } from './vscode/src/vs/workbench/services/textmodelResolver/common/textModelResolverService.js';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';

function getServiceOverride() {
    return {
        [( ITextModelService.toString())]: new SyncDescriptor(TextModelResolverService, undefined, true)
    };
}

export { getServiceOverride as default };
